import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { resetAuthentication } from '../stores/auth';

export function useLogout() {
  const router = useRouter();

  return useCallback(async () => {
    resetAuthentication();
    await router.replace('/api/auth/logout');
    return;
  }, [router]);
}
